import i18n from '@i18next/i18n';
import { ReColorStyleItem } from '.';
import { STSchemeColorVal } from '@tencent/slide-sdk-model';

export const ReColorStyleList: ReColorStyleItem[] = [
    {
        style: {}, key: 'noRecolor', title: i18n.t('不重新着色'),
    },
    {
        style: { grayscl: true }, key: 'gray', title: i18n.t('灰度'),
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'rgb',
                    colorValue: '000000',
                },
                clr2: {
                    colorType: 'rgb',
                    colorValue: 'D9C3A5',
                    tint: 50000,
                    satMod: 180000,
                },
            },
        },
        key: 'brown',
        title: i18n.t('褐色'),
    },
    {
        style: {
            luminance: {
                brightness: 70,
                contrast: -70,
            },
        },
        key: 'erosion',
        title: i18n.t('冲蚀'),
    },
    {
        style: {
            biLevel: 25,
        },
        key: 'biLevel-25',
        title: `${i18n.t('黑白')}: 25%`,
    },
    {
        style: {
            biLevel: 50,
        },
        key: 'biLevel-50',
        title: `${i18n.t('黑白')}: 50%`,
    },
    {
        style: {
            biLevel: 75,
        },
        key: 'biLevel-75',
        title: `${i18n.t('黑白')}: 75%`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'rgb',
                    colorValue: '000000',
                },
                clr2: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.tx2,
                    tint: 45000,
                    satMod: 400000,
                },
            },
        },
        key: 'duotone-1',
        title: `${i18n.t('文本颜色')} 2 ${i18n.t('深色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'rgb',
                    colorValue: '000000',
                },
                clr2: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent1,
                    tint: 45000,
                    satMod: 400000,
                },
            },
        },
        key: 'duotone-2',
        title: `${i18n.t('个性色')} 1 ${i18n.t('深色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'rgb',
                    colorValue: '000000',
                },
                clr2: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent2,
                    tint: 45000,
                    satMod: 400000,
                },
            },
        },
        key: 'duotone-3',
        title: `${i18n.t('个性色')} 2 ${i18n.t('深色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'rgb',
                    colorValue: '000000',
                },
                clr2: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent3,
                    tint: 45000,
                    satMod: 400000,
                },
            },
        },
        key: 'duotone-4',
        title: `${i18n.t('个性色')} 3 ${i18n.t('深色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'rgb',
                    colorValue: '000000',
                },
                clr2: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent4,
                    tint: 45000,
                    satMod: 400000,
                },
            },
        },
        key: 'duotone-5',
        title: `${i18n.t('个性色')} 4 ${i18n.t('深色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'rgb',
                    colorValue: '000000',
                },
                clr2: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent5,
                    tint: 45000,
                    satMod: 400000,
                },
            },
        },
        key: 'duotone-6',
        title: `${i18n.t('个性色')} 5 ${i18n.t('深色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'rgb',
                    colorValue: '000000',
                },
                clr2: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent6,
                    tint: 45000,
                    satMod: 400000,
                },
            },
        },
        key: 'duotone-7',
        title: `${i18n.t('个性色')} 6 ${i18n.t('深色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.bg2,
                    shade: 45000,
                    satMod: 135000,
                },
                clr2: {
                    colorType: 'rgb',
                    colorValue: 'FFFFFF',
                },
            },
        },
        key: 'duotone-8',
        title: `${i18n.t('背景颜色')} 2 ${i18n.t('浅色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent1,
                    shade: 45000,
                    satMod: 135000,
                },
                clr2: {
                    colorType: 'rgb',
                    colorValue: 'FFFFFF',
                },
            },
        },
        key: 'duotone-9',
        title: `${i18n.t('个性色')} 1 ${i18n.t('浅色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent2,
                    shade: 45000,
                    satMod: 135000,
                },
                clr2: {
                    colorType: 'rgb',
                    colorValue: 'FFFFFF',
                },
            },
        },
        key: 'duotone-10',
        title: `${i18n.t('个性色')} 2 ${i18n.t('浅色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent3,
                    shade: 45000,
                    satMod: 135000,
                },
                clr2: {
                    colorType: 'rgb',
                    colorValue: 'FFFFFF',
                },
            },
        },
        key: 'duotone-11',
        title: `${i18n.t('个性色')} 3 ${i18n.t('浅色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent4,
                    shade: 45000,
                    satMod: 135000,
                },
                clr2: {
                    colorType: 'rgb',
                    colorValue: 'FFFFFF',
                },
            },
        },
        key: 'duotone-12',
        title: `${i18n.t('个性色')} 4 ${i18n.t('浅色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent5,
                    shade: 45000,
                    satMod: 135000,
                },
                clr2: {
                    colorType: 'rgb',
                    colorValue: 'FFFFFF',
                },
            },
        },
        key: 'duotone-13',
        title: `${i18n.t('个性色')} 5 ${i18n.t('浅色')}`,
    },
    {
        style: {
            duotone: {
                clr1: {
                    colorType: 'scheme',
                    colorValue: STSchemeColorVal.accent6,
                    shade: 45000,
                    satMod: 135000,
                },
                clr2: {
                    colorType: 'rgb',
                    colorValue: 'FFFFFF',
                },
            },
        },
        key: 'duotone-14',
        title: `${i18n.t('个性色')} 6 ${i18n.t('浅色')}`,
    },
];
